import { useTranslation } from 'react-i18next';
import BrowserChromePicture from '@/assets/images/browser-chrome.png?w=20&format=avif;webp&as=picture';
import BrowserEdgePicture from '@/assets/images/browser-edge.png?w=20&format=avif;webp&as=picture';
import BrowserSafariPicture from '@/assets/images/browser-safari.png?w=20&format=avif;webp&as=picture';
import PicturizedImage from '@/components/common/picturized-image';

export default function BrowserList() {
  const { t } = useTranslation();

  return (
    <ul className='text-metal-700 text-body1 my-1.5 flex flex-col gap-1'>
      <li>
        <PicturizedImage
          className='size-5 inline-block me-1.5'
          picture={BrowserEdgePicture}
        />
        {t('compatibility.browser-version', { brand: 'Edge', version: '111' })}
      </li>
      <li>
        <PicturizedImage
          className='size-5 inline-block me-1.5'
          picture={BrowserChromePicture}
        />
        {t('compatibility.browser-version', { brand: 'Chrome', version: '111' })}
      </li>
      <li>
        <PicturizedImage
          className='size-5 inline-block me-1.5'
          picture={BrowserSafariPicture}
        />
        {t('compatibility.browser-version', { brand: 'Safari', version: '16.4' })}
        {t('compatibility.recommended-for-ios')}
      </li>
    </ul>
  );
}
